import jQuery from 'jquery';
import {enableLog, log, warn} from '../util/logger';
import {validateEmail} from '../util/validation';

if ('development' === process.env.NODE_ENV) {
  enableLog('Norrtåg Newsletter: ');
}

const checkEmail = (email, form) => {
  const formContainer = jQuery(form).parents('.js-subscribeFormContainer');

  if (!validateEmail(email)) {
    formContainer.find('.js-subscribeFormInput, .js-subscribeFormSubmit').addClass('is-failed');
    formContainer.find('.js-subscribeFormError').show();
    formContainer.find('.js-subscribeFormSuccess').hide();

    return;
  }

  formContainer.find('.js-subscribeFormError').hide();
  formContainer.find('.js-subscribeFormInput, .js-subscribeFormSubmit').removeClass('is-failed');
  formContainer.find('.js-subscribeFormSubmit').val(newsletterSettings.signupFormSubmitWait);

  jQuery.post(
    newsletterSettings.endpoint,
    {email: email},
    function (data) {
      if (data === 'success') {
        try {
          ga('send', 'event', 'forms', 'Success', 'Newsletter signup');
        } catch (error) {
          warn('GA error', error);
        }
        formContainer.addClass('is-success').removeClass('is-fail');
        formContainer.find('.js-subscribeFormField').hide();
        formContainer.find('.js-subscribeFormSuccess').show();
      } else if (data === 'already subscribed') {
        try {
          ga('send', 'event', 'forms', 'Already subscribed to list', 'Newsletter signup');
        } catch (error) {
          warn('GA error', error);
        }
        formContainer.find('.js-subscribeFormSuccess').hide();
        formContainer.addClass('success').removeClass('is-failed');
        formContainer.find('.js-subscribeFormError').html(newsletterSettings.userAlreadySubscribed).show();
      }
    }
  ).fail(() => {
    try {
      ga('send', 'event', 'forms', 'Failed', 'Newsletter signup');
    } catch (error) {
      warn('GA error', error);
    }
    formContainer.find('.js-subscribeFormSuccess').hide();
    formContainer.find('.js-subscribeFormError').html(newsletterSettings.errorMessage).show();
  }).always(() => {
    formContainer.find('.js-subscribeFormSubmit').val(newsletterSettings.signupFormSubmitActive);
  });


  return false;
};

jQuery(document).ready(() => {
  jQuery('.js-subscribeForm').on('submit', function (event) {
    event.preventDefault();
    const email = jQuery('.js-subscribeFormInput', this).val();
    checkEmail(email, this);
  });

  log('NewsletterSignup init', newsletterSettings);
});
